module.exports = __webpack_public_path__ + "static/media/icon_orden_ascendente.e0277fdf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_orden_ascendente.svg
// module id = 631
// module chunks = 0